import React from "react";
import { GridCellProps } from "@progress/kendo-react-grid";
import { getScoreStyle } from "../utils/scoreColors";

const ScoreCell: React.FC<GridCellProps> = (props) => {
  const value = props.dataItem[props.field ?? ""];
  const style = getScoreStyle(value);

  return (
    <td style={style}>
      {value || ""}
    </td>
  );
};

export default ScoreCell;
